/**
 * Compact formatters for the mobile Super Dashboard overview areas.
 * Detail views keep using mixinBase.convertToEURO for exact amounts.
 */

const compact = new Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 2 });
const plain = new Intl.NumberFormat('en');

export function compactNumber(value) {
  if (value == null || isNaN(value)) return '—';
  return compact.format(value);
}

export function compactEuro(value) {
  if (value == null || isNaN(value)) return '—';
  return `€${compact.format(value)}`;
}

// Full exact amount, same format as mixinBase.convertToEURO (desktop dashboards)
const euroFull = new Intl.NumberFormat('de-AT', { style: 'currency', currency: 'EUR' });

export function fullEuro(value) {
  if (value == null || isNaN(value)) return '—';
  return euroFull.format(value);
}

export function wholeNumber(value) {
  if (value == null || isNaN(value)) return '—';
  return plain.format(Math.round(value));
}

export function pct(value, digits = 2) {
  if (value == null || isNaN(value)) return '—';
  return `${Number(value).toFixed(digits)}%`;
}

/**
 * Percentage change between periods. Returns null when the previous value is
 * missing/zero (a percentage there would be misleading) — callers render "new"
 * or nothing instead.
 */
export function deltaPct(current, previous) {
  const cur = Number(current) || 0;
  const prev = Number(previous);
  if (previous == null || isNaN(prev) || prev === 0) return null;
  return ((cur - prev) / Math.abs(prev)) * 100;
}
